import { Box, Checkbox, Typography } from '@mui/material';
import { QuestionOption } from '../ScheduleQuestionRadioGroup/ScheduleQuestionRadioGroup';
interface ScheduleQuestionCheckboxProps {
  options: QuestionOption[];
  answers: string[];
  short_name: string;
  handleChange: (short_name: string) => void;
}
export default function ScheduleQuestionCheckbox({
  options,
  answers,
  short_name,
  handleChange
}: ScheduleQuestionCheckboxProps) {
  return options.map((option: QuestionOption) => {
    const isChecked = Boolean(answers?.includes(option.short_name));
    const inputId = `${short_name}-${option.short_name}`;
    return <Box key={option.short_name} sx={{
      display: 'flex',
      py: {
        md: 2,
        xs: 1
      }
    }}>
				<Checkbox id={inputId} checked={isChecked} onChange={() => handleChange(option.short_name)} sx={{
        padding: 0,
        pr: 1
      }} />
				<label htmlFor={inputId}>
					<Typography sx={{
          cursor: 'pointer'
        }} variant="bodyMediumBook">
						{option.option_value}
					</Typography>
				</label>
			</Box>;
  });
}